<template lang="html">

  <div>

   <section class="intro-simulador container">
    <h2>Calculando...</h2>
  </section>

  <div class="loading column-center ">


    <div class="loading-circle row-center">
      <h2>{{contador}}%</h2>
      <span class="circle"></span>
    </div>

    <h4>Este proceso solo nos llevará unos segundos.</h4>
    <h4>¡Ten paciencia!</h4>

    
  </div>

</div>

</template>

<script lang="js">
  export default  {
    name: 'loading-view',
    props : [],
    mounted(){
      let interval = setInterval(e =>{
        this.contador++;
        if(this.contador >= 100){
          clearInterval(interval);
          this.$emit('fin');
        }
      },25)
    },
    data(){
      return{
          contador : 0
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .loading{
    min-height: 500px;
  }

  .loading-circle{
    width: 250px;
    height: 250px;
    position: relative;
    margin-bottom: 50px;

    h2{
      position: relative;
      font-size: 60px;
      font-weight: 800;
      color: $orange-light;
      z-index: 3;
      margin-bottom: 0;
    }
    
    .circle{
      width: 100%;
      height: 100%;
      background: $degree;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 0;
      animation-name: rotate;
      animation-duration: 2s;
      animation-iteration-count: infinite;

      &::before{
        content:'';
        display: inline-block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: white;
        border-radius: 50%;
        transform: scale(.85);
      }

    }

  }

  h4:last-child{
    margin-top: 10px;
  }

  @keyframes rotate{
    from{
      transform: rotate(0deg);
    }
    50%{
      transform: rotate(360deg);
    }
    to{
      transform: rotate(0deg);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/view-parts/simulador/loading-view.vue